import React from 'react';
import { formatDate } from '@shootsta/get-moment';
import UserProfile from '../../../../../../../common/UserProfile';
import { Icon, LucideIcon, Text, ToolTip } from '../../../../../../../../../ui-kit';
import { Pencil, Trash2, CheckCircle } from 'lucide-react';
import { COMMENT_VISIBILITY_STYLES } from '../../../../../../../constants/commentVisibilityStyles';

import '../styles/_comment-v2-header.scss';

























function formatViewers(viewers) {
  if (!viewers || !viewers.length) return '';

  const viewerCount = viewers.length;
  const formattedViewers = viewers.map(
    ({ firstName, lastName }) => `${firstName} ${lastName.charAt(0)}`
  );

  if (viewerCount > 3) {
    return `${formattedViewers.slice(0, 3).join(', ')}, + ${viewerCount - 3}`;
  }

  return formattedViewers.join(', ');
}

const CommentV2Header = ({
  user,
  commentIndex,
  comment,
  commentOrderByTimeline,
  brightness,
  canResolveComment,
  isEditable,
  isDeletable,
  toggleEditMode,
  handleDelete,
  onUpdateCheckbox,
  updateComment,
  deleteComment,
  hovering,
  isChildren,
  parentComment,
  handleDeleteReply,
  deleteReply,
  isStoryboard = false,
  showShotName,
  shotsMap
}) => {
  const {
    isResolved,
    commentId,
    updatedAt,
    viewers = [],
    metadata,
    number,
    shotId
  } = comment;
  const shotName = shotsMap && shotsMap.get(shotId) || '';
  const {
    assetId,
    clipId,
    visibility = 'PUBLIC',
    isRejected
  } = JSON.parse(metadata || '{}');
  const { name, isUser } = user || {};

  const handleDeleteClick = () =>
  isChildren && handleDeleteReply ?
  handleDeleteReply({ commentId, parentComment, deleteReply }) :
  handleDelete({ commentId, deleteComment });

  return (
    <div className="flex flex-col">
      {showShotName && shotName &&
      <Text className="font-medium text-xs leading-5 text-right text-[#515E71] py-1">
          {shotName}
        </Text>}

      <div className="comment-v2-header__container">
        <div className="comment-v2-header__container--left">
          {assetId || clipId ?
          <>
              {!isRejected ?
            <div
              className="comment-v2-header__container--left__number"
              style={{
                backgroundColor:
                COMMENT_VISIBILITY_STYLES[visibility].bgColor,
                color: COMMENT_VISIBILITY_STYLES[visibility].textColor,
                filter: brightness
              }}>

                  <Text timestamp darkTheme noMargin>
                    {commentOrderByTimeline}
                  </Text>
                </div> :
            null}
              <Text
              label
              noMargin
              className="comment-v2-header__container--left__user"
              ellipsisOverflow>

                {isUser ? 'You' : name}
              </Text>
            </> :

          <div className="comment-v2-header__profile">
              {isChildren &&
            <Icon
              name="line"
              className="comment-v2-header__profile__thread-line" />}



              <UserProfile
              name={name}
              isUser={isUser}
              width={24}
              height={24}
              hideProfile={isRejected || isStoryboard && isChildren}
              number={number}
              isStoryboard={isStoryboard} />

            </div>}

          <ToolTip
            id={`comment-v2-header__container--left__timestamp-${commentIndex}`}
            label={formatDate(updatedAt, 'MMM D, YYYY, hh:MM A')}>

            <span>
              <Text
                timestamp
                noMargin
                className="comment-v2-header__container--left__timestamp">

                {formatDate(updatedAt, 'MMM D')}
              </Text>
            </span>
          </ToolTip>
        </div>
        {hovering &&
        <div className="comment-v2-header__container--right">
            <ToolTip
            id="comment-v2-header__container--right__viewers"
            label={formatViewers(viewers)}>

              <span>
                <Text
                timestamp
                noMargin
                className="comment-v2-header__container--left__timestamp">

                  {`${viewers.length} Read`}
                </Text>
              </span>
            </ToolTip>
            {isEditable ?
          <LucideIcon
            icon={Pencil}
            color="slateBlueGray"
            hoverColor="darkDenim"
            size={16}
            onClick={() => toggleEditMode(commentId)}
            wrapperClassName="comment-v2-header__container--right--edit flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" /> :

          null}

            {isDeletable ?
          <LucideIcon
            icon={Trash2}
            color="slateBlueGray"
            hoverColor="redApple"
            size={16}
            onClick={handleDeleteClick()}
            wrapperClassName="comment-v2-header__container--right--delete flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-red-50" /> :

          null}
          </div>}

        {canResolveComment && !isChildren ?
        <LucideIcon
          color={isResolved ? 'monkey' : 'slateBlueGray'}
          hoverColor={isResolved ? 'monkey' : 'darkDenim'}
          icon={CheckCircle}
          size={16}
          onClick={onUpdateCheckbox({
            commentId,
            isResolved,
            updateComment
          })}
          wrapperClassName="comment-v2-header__container__read flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" /> :

        null}
      </div>
    </div>);

};

export default CommentV2Header;